"use client";
import EditorLeaf from "./EditorLeaf";
import PerfectScrollbar from "react-perfect-scrollbar";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { arrayMoveImmutable } from "array-move";
import { useContext } from "react";
import { AppContext } from "./AppContext";
import { deepCopy, findIsAnimated } from "@/functions/fns";
import { icons } from "./icons";
import Background from "./Background";
import Duration from "./Duration";
import HueBar from "./HueBar";

const SortableItem = SortableElement((props) => <EditorLeaf {...props} />);
const SortableList = SortableContainer((props) => (
	<ul className="border-color divide-color flex flex-col divide-y overflow-hidden rounded-md border">
		{props.config.map((value, index) => (
			<SortableItem
				{...props}
				key={`item-${index}`}
				index={index}
				ob={value}
				idx={index}
			/>
		))}
	</ul>
));

export function Editor() {
	const { config, setConfig, setOpenLeaf, setIsEditing } =
		useContext(AppContext);
	const onSortEnd = ({ oldIndex, newIndex }) =>
		setConfig((config) => arrayMoveImmutable(config, oldIndex, newIndex));

	const addPoint = () => {
		const newConfig = deepCopy(config);
		newConfig.push(newConfig[newConfig.length - 1]);
		setConfig(newConfig);
	};

	return (
		<>
			<div className="flex items-center justify-between pl-2 ">
				<div>Editor</div>
				<div
					onClick={() => setIsEditing(false)}
					className="flexer h-10 w-10 cursor-pointer"
				>
					{icons.close}
				</div>
			</div>
			<HueBar />
			<Background />

			<div className="flex flex-1 flex-col overflow-hidden">
				<div className="title">Color Points</div>
				<PerfectScrollbar
					options={{ wheelPropagation: false }}
					className="flex-1"
				>
					<SortableList
						useDragHandle={true}
						config={config}
						onSortEnd={onSortEnd}
						onSortStart={() => setOpenLeaf(null)}
					/>
					<div
						className="flexer h-12 cursor-pointer gap-2 opacity-75 transition-all hover:opacity-100"
						onClick={addPoint}
					>
						<div className="flexer h-4 w-4 rounded-full bg-dark-400 text-white dark:text-dark-900">
							<div className="scale-75">{icons.plus}</div>
						</div>
						Add Color
					</div>
				</PerfectScrollbar>
			</div>

			{findIsAnimated({ config }) && <Duration />}
		</>
	);
}
